export default class Counter {
  constructor(element) {
    this.element = element;
    this.target = this.getNumber(this.element.dataset.counterTarget || this.element.dataset.counter, 0);
    this.duration = this.getNumber(this.element.dataset.counterDuration, 1200);
    this.decimals = this.getNumber(this.element.dataset.counterDecimals, 0);
    this.prefix = this.element.dataset.counterPrefix || '';
    this.suffix = this.element.dataset.counterSuffix || '';
    this.hasAnimated = false;

    this.init();
  }

  getNumber(value, fallback) {
    const number = Number.parseFloat(value);

    return Number.isFinite(number) ? number : fallback;
  }

  init() {
    this.render(0);

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.start();
            this.observer.disconnect();
          }
        });
      }, { threshold: 0.35 });

      this.observer.observe(this.element);
      return;
    }

    this.start();
  }

  start() {
    if (this.hasAnimated) {
      return;
    }

    this.hasAnimated = true;
    this.startTime = null;
    window.requestAnimationFrame(this.animate.bind(this));
  }

  animate(timestamp) {
    if (!this.startTime) {
      this.startTime = timestamp;
    }

    const progress = Math.min((timestamp - this.startTime) / this.duration, 1);
    const easedProgress = 1 - Math.pow(1 - progress, 3);
    const value = this.target * easedProgress;

    this.render(value);

    if (progress < 1) {
      window.requestAnimationFrame(this.animate.bind(this));
    }
  }

  render(value) {
    const formattedValue = value.toLocaleString('fr-CA', {
      minimumFractionDigits: this.decimals,
      maximumFractionDigits: this.decimals,
    });

    this.element.textContent = `${this.prefix}${formattedValue}${this.suffix}`;
  }
}
